import { Input } from "antd";
import Colors from "assets/Colors";

function CustomInput(props) {
  return (
    <Input
      allowClear
      {...props}
      style={{
        height: "40px",
        width: "100%",
        borderColor: props.valid
          ? Colors.notification_failed
          : Colors.background_dividers,
        borderRadius: "5px",
        borderStyle: "solid",
        ...props.style,
      }}
    />
  );
}

export default CustomInput;
